import { useMemo } from 'react';
import { useExperience } from '../contexts/experience';
import MapSpotLayer from './MapSpotLayer';

const MapSpots = () => {
  const { mapSpots, active, videoActive } = useExperience();

  const activeSpotsIds = useMemo(
    () => active?.map((spot) => spot?.id).concat(videoActive?.map((spot) => spot?.spotId)),
    [active, videoActive]
  );

  return (
    // eslint-disable-next-line
    <>
      {mapSpots?.map((spot) => (
        <MapSpotLayer key={`${spot.id}_layer`} activeSpotsIds={activeSpotsIds} spot={spot} />
      ))}
    </>
  );
};

export default MapSpots;
